export enum DanceStyleRoleEnum {
    FOLLOWER = "FOLLOWER",
    LEADER = "LEADER",
    NOT_IMPORTANT = "NOT_IMPORTANT"
}
